import {
  CSSProperties,
  HTMLProps,
  MouseEventHandler,
  PropsWithChildren,
  RefObject,
} from "react";
import styled from "styled-components";
import { FloatingRootContext, UseFloatingReturn } from "@floating-ui/react";
import { zIndex } from "../../styles/constants";
import { elevation03, shade950 } from "../../styles/tokens";

// TEXT

// STYLES
export const Wrapper = styled.div<WrapperProps>`
  z-index: ${zIndex.dropdown};
  position: relative;
  display: flex;
  box-shadow: ${elevation03};
`;

export const Content = styled.div<ContentProps>`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  padding: 0.5rem 0;
  background-color: ${shade950};

  ${({ $maxHeight }) => $maxHeight && `max-height: ${$maxHeight}`};
  ${({ $maxWidth }) => $maxWidth && `max-width: ${$maxWidth}`};
  ${({ $minHeight }) => $minHeight && `min-height: ${$minHeight}`};
  ${({ $minWidth }) => $minWidth && `min-width: ${$minWidth}`};
`;

// DATA

// TYPES
export interface Props extends PropsWithChildren {
  id?: string;
  context: FloatingRootContext;
  refs: UseFloatingReturn["refs"];
  floatingStyles: CSSProperties;
  getFloatingProps: (
    props?: HTMLProps<HTMLElement> | undefined,
  ) => Record<string, unknown>;
  initialFocus?: number | RefObject<HTMLElement | null>;
  /**
   * Optional mouse down handler for the dropdown shell
   * to prevent closing side effects when used within certain parent components.
   * E.g., preventing the select's input from losing focus when clicking inside the dropdown.
   */
  onMouseDown?: MouseEventHandler<HTMLDivElement>;
  maxHeight?: string;
  maxWidth?: string;
  minHeight?: string;
  minWidth?: string;
  /**
   * Whether the dropdown is floating or not. When the dropdown is rendered inside of a modal this generally should be set to false to prevent bugs with layering.
   */
  floating?: boolean;
}

type WrapperProps = {
  $modal?: boolean;
};

type ContentProps = {
  $maxHeight?: string | number;
  $maxWidth?: string | number;
  $minHeight?: string | number;
  $minWidth?: string | number;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
